import * as React from "react";
import classNames from "classnames";
import { ITab } from "~/components/tabs/tabs";

export interface ITabMenuProps {
    tabs: ITab[];
    selectedKey: string;
    tabClickHandler: (tabkey: string) => void;
    className?: string;
}

const TabMenu: React.SFC<ITabMenuProps> = props => {
    return (
        <div className={classNames("tab-menu", props.className)}>
            {props.tabs.map(tab => {
                const btnClassName = classNames("tab-menu__button", {
                    "tab-menu__button--isSelected": tab.key === props.selectedKey
                });

                return (
                    <button
                        className={btnClassName}
                        key={tab.key}
                        type="button"
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                            e.preventDefault();
                            props.tabClickHandler(tab.key);
                        }}
                    >
                        {tab.label}
                    </button>
                );
            })}
        </div>
    );
};

export default TabMenu;
